import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'wlm-map-popup-wrapper',
  templateUrl: './map-popup-wrapper.component.html',
  styleUrl: './map-popup-wrapper.component.scss',
  standalone: false,
})
export class MapPopupWrapperComponent {
  @Input() titleKey: string;
  @Input() titleKeyParams: { [id: string]: string };
  @Input() title: string;
  @Input() subTitle: string;
  @Input() customTitle: string;
  @Input() showSpinner = false;
  @Input() styles: any;
  @Input() showCloseButton = true;
  @Input() actionsContainerClass = '';
  @Input() contentContainerClass = '';
  @Input() popupContainerClass = '';
  @Input() showArrowIcon = true;
  @Input() popupWidth?: string;
  @Output() popupClose = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  onClose(): void {
    this.popupClose.emit();
  }
}
